<template>
  <div class="linha-grade-horaria d-flex flex-column pa-2">
    <template v-if="!linha || !linha.id_linha">
      <v-alert type="info" dense outlined>{{ $t('crudLinhas.detail.selectLine') }}</v-alert>
    </template>
    <template v-else>
      <v-progress-linear v-if="loading" indeterminate color="primary" class="mb-2" />
      <v-select
        v-model="idQuadro"
        :items="quadros"
        item-text="descricao"
        item-value="id_quadro"
        :label="$t('crudLinhas.detail.schedule.selectSchedule')"
        dense
        outlined
        hide-details
        class="mb-3 flex-grow-0"
        :disabled="!quadros.length"
      />

      <v-alert v-if="!loading && !quadros.length" type="info" dense outlined class="flex-grow-0">
        {{ $t('crudLinhas.detail.schedule.empty') }}
      </v-alert>

      <v-data-table
        v-else
        :headers="headers"
        :items="viagensVisiveis"
        :loading="loadingViagens"
        dense
        class="elevation-1"
        :items-per-page="15"
        :no-data-text="$t('crudLinhas.detail.schedule.noTrips')"
      />
    </template>
  </div>
</template>

<script>
import apiController from "@/utils/apiController";
import EventBus from "@/utils/eventBus";

export default {
  name: "LinhaGradeHoraria",
  props: {
    linha: { type: Object, default: null },
    token: { type: String, default: null },
    sentidoSelecionado: { type: [Number, String], default: null },
  },
  data() {
    return {
      loading: false,
      loadingViagens: false,
      quadros: [],
      idQuadro: null,
      viagens: [],
    };
  },
  computed: {
    headers() {
      return [
        { text: this.$t("crudLinhas.detail.schedule.departure"), value: "horario_saida" },
        { text: this.$t("crudLinhas.detail.schedule.arrival"), value: "horario_chegada" },
        { text: this.$t("crudLinhas.detail.schedule.direction"), value: "descricao_sentido" },
        { text: this.$t("crudLinhas.detail.schedule.shift"), value: "descricao_turno" },
        { text: this.$t("crudLinhas.detail.schedule.capacity"), value: "lotacao" },
      ];
    },
    viagensVisiveis() {
      const all = this.viagens || [];
      const s = this.sentidoSelecionado;
      if (s == null || Number(s) === -1) return all;
      return all.filter((v) => Number(v.id_sentido) === Number(s));
    },
  },
  watch: {
    linha: {
      immediate: true,
      deep: true,
      handler(linha) {
        if (linha && linha.id_linha != null) {
          this.loadQuadros();
        } else {
          this.quadros = [];
          this.idQuadro = null;
          this.viagens = [];
        }
      },
    },
    idQuadro(id) {
      if (id != null) this.loadViagens(id);
      else this.viagens = [];
    },
  },
  methods: {
    async loadQuadros() {
      const idLinha = this.linha && this.linha.id_linha;
      if (!idLinha) return;
      this.loading = true;
      try {
        const res = await apiController.request(apiController.endpoints.getQuadrosporlinha, {
          params: { id_linha: idLinha },
          silent: true,
        });
        this.quadros = Array.isArray(res.data) ? res.data : [];
        const ativo = this.quadros.find((q) => q.ativo === 1 || q.ativo_extenso === "Sim");
        this.idQuadro = ativo
          ? ativo.id_quadro
          : this.quadros[0]
            ? this.quadros[0].id_quadro
            : null;
      } catch (e) {
        this.quadros = [];
        this.idQuadro = null;
        EventBus.$emit("show-error", { error: e });
      } finally {
        this.loading = false;
      }
    },
    async loadViagens(idQuadro) {
      this.loadingViagens = true;
      try {
        const res = await apiController.request(apiController.endpoints.getViagensporquadrobulk, {
          data: { quadros: [idQuadro] },
          silent: true,
        });
        this.viagens = Array.isArray(res.data) ? res.data : [];
      } catch (e) {
        this.viagens = [];
        EventBus.$emit("show-error", { error: e });
      } finally {
        this.loadingViagens = false;
      }
    },
  },
};
</script>
